var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","placement":"top-end","open-delay":_vm.openDelay,"content":_vm.tipContent}},[_c('el-button',{class:_vm.btnClass,attrs:{"type":_vm.btnType,"icon":_vm.btnIcon,"size":_vm.btnSize,"loading":_vm.isLoading,"disabled":_vm.isDisabled},on:{"click":_vm.click}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }